import Blue from "../core";

new Blue({
	name: 'Color Picker',
	selector: ".color-picker",
	setup(container) {
		const items = [...container.querySelectorAll(".color-picker__option")];

		items.forEach(item => {
			const currentColorEl = item.querySelector(".color-picker__option-current");
			const colorOptionSquares = [...item.querySelectorAll(".color-picker__color[data-color]")];
      let trigger = item.querySelector('.color-picker__trigger')
      let content = item.querySelector('.color-picker__content')
      let config = {
        item,
        trigger,
        content,
      }
			let togglet = new this.$toggle(config);
			
			let currentColorVal = !!currentColorEl.getAttribute("data-current-color") ? currentColorEl.getAttribute("data-current-color") : colorOptionSquares[0].getAttribute("data-color");

			const setCurrentColor = color => {
				currentColorVal = color;
				currentColorEl.style.background = currentColorVal;
				currentColorEl.setAttribute("title", `Current color is ${currentColorVal}`);
			}

			setCurrentColor(currentColorVal);

			colorOptionSquares.forEach(square => {
				const colorVal = square.getAttribute("data-color");
				square.style.background = colorVal;
				square.setAttribute("title", colorVal);
				square.setAttribute("tabindex", "0");

				this.$addEvents(square, "click enter", () => setCurrentColor(colorVal));
			});
		});
	}
});